<template>
  <div>
    <v-dialog width="500" max-width="100vw" v-model="changeCompanyDialog">
      <og-company-selector></og-company-selector>
    </v-dialog>

    <v-toolbar
      class="og-main-toolbar"
      light
      color="primary"
      app
      :clipped-left="clipped"
      :fixed="fixed"
      :height="toolbarHeight"
    >
      <v-toolbar-side-icon class="ml-2" @click.stop="drawer = !drawer">
        <v-icon>mdi-menu</v-icon>
      </v-toolbar-side-icon>

      <!-- <v-btn icon @click.stop="clipped = !clipped">
        <v-icon>web</v-icon>
      </v-btn>-->
      <v-toolbar-items>
        <v-divider vertical></v-divider>
        <template v-for="(item, i) in toolbarItems">
          <v-btn
            :key="i"
            v-bind:class="{ 'white--text': currentRoute === item.path }"
            v-if="!item.meta.adminRightToolbar && item.meta.admin && $store.state.admin"
            flat
            :to="item.path"
          >
            <v-icon class="pr-2">{{ item.icon }}</v-icon>
            {{ $t(item.name) }}
          </v-btn>
        </template>
      </v-toolbar-items>

      <v-spacer></v-spacer>
      <v-toolbar-items>
        <!-- Fixme Set the url according to the current domain-->
        <v-btn v-if="$store.state.admin" flat :href="viewCustomerAreaUrl">
          <v-icon class="pr-2">mdi-eye</v-icon>
          Ver sitio
        </v-btn>
        <template v-for="(item, i) in toolbarItems">
          <v-btn
            :key="i"
            v-bind:class="{ 'white--text': currentRoute === item.path }"
            v-if="item.meta.adminRightToolbar && item.meta.admin && $store.state.admin"
            flat
            :to="item.path"
          >
            <v-icon class="pr-2">{{ item.icon }}</v-icon>
            {{ $t(item.name) }}
          </v-btn>
        </template>

        <v-menu offset-y origin="center center" transition="scale-transition">
          <v-btn slot="activator" color="grey" class="white--text" depressed>
            <span class="text-capitalize">
              {{ accountName | truncate(20, '...') }}
            </span>
            <v-icon class="white--text ml-3" dark>mdi-account-circle-outline</v-icon>
          </v-btn>
          <v-card>
            <v-list>
              <v-list-tile @click="changeCompanyDialog = true">
                <v-list-tile-title>{{ $t('Cambiar entre mis empresas') }}</v-list-tile-title>
              </v-list-tile>
              <v-list-tile to="/user/myaccount">
                <v-list-tile-title>{{ $t('Configurar cuenta') }}</v-list-tile-title>
              </v-list-tile>
              <v-list-tile to="/user/myprofile">
                <v-list-tile-title>{{ $t('Datos de usuario') }}</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="logout()">
                <v-list-tile-title>{{ $t('Salir') }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>
    <v-navigation-drawer
      floating
      class="og-main-sidebar"
      width="200"
      mini-variant-width="65"
      persistent
      :mini-variant="miniVariant"
      :clipped="clipped"
      v-model="drawer"
      enable-resize-watcher
      app
    >
      <v-layout py-0 column fill-height>
        <v-list class="pa-0">
          <v-list-tile :style="{ height: toolbarHeight + 'px' }" class="grey lighten-2 elevation-1">
            <v-img
              v-if="miniVariant"
              contain
              :height="toolbarHeight - 10"
              src="/img/mini-logo.png"
            ></v-img>
            <v-img v-else contain :height="toolbarHeight - 10" src="/img/logo.png"></v-img>
          </v-list-tile>
          <v-list-tile @click.stop="miniVariant = !miniVariant">
            <v-list-tile-action class="pr-0">
              <v-icon
                large
                color="primary"
                v-html="miniVariant ? 'mdi-chevron-right' : 'mdi-chevron-left'"
              ></v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title v-text="$t('Minimizar')"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>

        <v-list>
          <v-list-tile v-for="(item, i) in drawerItems" :key="i" :to="item.path">
            <v-list-tile-action class="pr-0">
              <v-badge
                v-if="miniVariant && item.meta.adminBadge && $data[item.meta.adminBadgeContent]"
              >
                <span slot="badge">
                  <template v-if="$data[item.meta.adminBadgeChecker]">
                    {{ $data[item.meta.adminBadgeContent] }}
                  </template>
                </span>
                <v-icon v-html="item.icon"></v-icon>
              </v-badge>
              <v-icon v-else v-html="item.icon"></v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-badge v-if="item.meta.adminBadge && $data[item.meta.adminBadgeContent]">
                <span slot="badge">
                  <template v-if="$data[item.meta.adminBadgeChecker]">
                    {{ $data[item.meta.adminBadgeContent] }}
                  </template>
                </span>
                <v-list-tile-title
                  class="caption font-weight-medium"
                  v-text="item.name"
                ></v-list-tile-title>
              </v-badge>
              <v-list-tile-title v-else v-text="item.name"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-spacer></v-spacer>
        <v-list class="py-5">
          <v-list-tile
            :style="{ height: miniVariant ? '36px' : '100px' }"
            class="text-xs-center py-0"
          >
            <v-img>
              <v-icon :size="miniVariant ? '36px' : '100px'" color="secondary">
                mdi-lightbulb-on-outline
              </v-icon>
            </v-img>
          </v-list-tile>

          <v-list-tile v-if="!miniVariant" class="pt-0">
            <v-list-tile-content>
              <v-list-tile-title class="text-xs-center">CENTRO DE AYUDA</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-layout>
    </v-navigation-drawer>
  </div>
</template>

<script>
import OgCompanySelector from '@/components/commons/OgCompanySelector.vue';
import apiCtrl from '@/services/api/abstract/abstract-api.js';
import AruRouteGuardMixin from '@/mixins/route-guards/AruRouteGuardMixin.js';

export default {
  mixins: [AruRouteGuardMixin],

  components: {
    OgCompanySelector,
  },
  data() {
    return {
      clipped: false,
      drawer: true,
      fixed: false,
      toolbarHeight: 50,
      miniVariant: true,
      changeCompanyDialog: false,
      userEventsReady: false,
      unreadedUserEvent: 0,
      unreadedLaboralRequests: 0,
      userLaboralRequestsReady: false,
    };
  },
  mounted() {
    this.getEventNotifications();
    this.getLaboralRequests();
  },
  computed: {
    viewCustomerAreaUrl() {
      // https://tst.my.openges.es/v2/dashboard
      return location.protocol + '//' + location.host + '/v2/dashboard';
    },
    user() {
      return this.$store.state.user;
    },
    accountName() {
      let companyName = null;
      if (
        this.$store.state.hasOwnProperty('clavedat') &&
        this.$store.state.hasOwnProperty('user') &&
        this.$store.state.user.hasOwnProperty('customer_profile') &&
        this.$store.state.user.customer_profile &&
        this.$store.state.user.customer_profile.hasOwnProperty('fiscal_data') &&
        Array.isArray(this.$store.state.user.customer_profile.fiscal_data)
      ) {
        this.$store.state.user.customer_profile.fiscal_data.forEach(company => {
          // console.log({ COMPANY: company });
          if (company.CLAVEDAT == this.$store.state.clavedat) {
            companyName = company.APELNOM;
          }
        });
      }
      return companyName ? companyName : this.user.name;
    },
    currentRoute() {
      return this.$router.currentRoute.fullPath;
    },
    toolbarItems() {
      let items = [];
      this.$router.options.routes.forEach(element => {
        if (
          element.hasOwnProperty('meta') &&
          element.meta.hasOwnProperty('adminToolbar') &&
          element.meta.adminToolbar &&
          this.userHasPermissions(element)
        ) {
          items.push(element);
        }
      });
      return items;
    },

    drawerItems() {
      let items = [];
      this.$router.options.routes.forEach(element => {
        if (
          element.hasOwnProperty('meta') &&
          element.meta.hasOwnProperty('adminDrawer') &&
          element.meta.adminDrawer &&
          this.userHasPermissions(element)
        ) {
          items.push(element);
        }
      });
      return items;
    },
    consultantId() {
      if (
        this.$store.state &&
        this.$store.state.user &&
        this.$store.state.user.consultant_profile
      ) {
        return this.$store.state.user.consultant_profile.id;
      }
      return null;
    },
    // drawerItems() {
    //   let result = [];
    //   let prefix = "/admin";
    //   let section = "";
    //   let segments = this.$router.currentRoute.fullPath.split("/");
    //   if (Array.isArray(segments) && segments[2]) {
    //     section = segments[2];
    //   }
    //   this.toolbarItems.forEach(element => {
    //     if (element.path.startsWith(prefix + "/" + section)) {
    //       console.log({
    //         "start with": prefix + "/" + section
    //       });
    //       console.log(element.children);
    //       if (element.hasOwnProperty("children")) {
    //         result = element.children;
    //       }
    //     }
    //   });

    //   return result;
    // }
  },
  methods: {
    getEventNotifications() {
      // console.log('getEventNotifications');
      this.userEventsReady = false;
      if (this.$store.state.user) {
        apiCtrl
          .get('/calendar-event', {
            params: {
              constraint: {
                consultant_id: this.consultantId,
                status: 'in_progress',
              },
            },
          })
          .then(res => {
            this.unreadedUserEvent =
              res.hasOwnProperty('data') &&
              res.data &&
              res.data.hasOwnProperty('data') &&
              res.data.data &&
              res.data.data.length
                ? res.data.data.length
                : 0;
            this.userEventsReady = true;
          });
      }
    },

    getLaboralRequests() {
      // console.log('getEventNotifications');
      this.userLaboralRequestsReady = false;
      if (this.$store.state.user) {
        apiCtrl
          .get('/laboral-requests', {
            params: {
              page: 1,
              per_page: 10,
              descending: true,
              readed: 'unreaded',
              show_my_customers: true,
              grouped_status: 'active',
            },
          })
          .then(res => {
            this.unreadedLaboralRequests =
              res.hasOwnProperty('data') &&
              res.data &&
              res.data.hasOwnProperty('data') &&
              res.data.data &&
              res.data.data.length
                ? res.data.data.length
                : 0;
            this.userLaboralRequestsReady = true;
          });
      }
    },

    logout() {
      this.$store.dispatch('logout').then(() => {
        window.location.href = '/v2/login';
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
